module.exports = __webpack_public_path__ + "static/media/black_discard.11df74e0.svg";